
import { GETSUPPLIERS, GETMYSUPPLIERS, GETMYRECIVEDSUPPLIER } from "../ActionTypes/SupplierTypes"

const initialState ={

    suppliers : [],
    mySuppliers : [],
    myRecivedSupplier : []

}

const SupplierReducer=(state=initialState,action)=>{

switch (action.type) {
        case GETSUPPLIERS : return {...state, suppliers: action.payload}
        case GETMYSUPPLIERS : return {...state, mySuppliers: action.payload}
        case GETMYRECIVEDSUPPLIER : return {...state, myRecivedSupplier: action.payload}
       default: return state
}
}

export default SupplierReducer